import { BaseDto } from "@/shared/dtos/base-dto";

export class ClassReportWizardFormFichajes extends BaseDto {
  public id_tipo_fichaje!: number[];
  public fecha_desde!: Date;
  public fecha_hasta!: Date;
  public id_empresa !:number;
  public id_centro_trabajo !:number;
}
